<template>
  <div>
    <nav-header
      ref="navHeader"
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <nav-bread>
      <span slot="confirmOrder">确认订单</span>
    </nav-bread>
    <div class="container" v-loading="loading">
      <div class="checkout-order">
        <!-- process step -->
        <div class="check-step">
          <ul>
            <li class="cur"><span>测试页选择地址</span></li>
            <li class="cur"><span>确认订单</span></li>
            <li><span>下单成功</span></li>
          </ul>
        </div>

        <!-- order list -->
        <div class="page-title-normal checkout-title">
          <h2><span>订单信息</span></h2>
        </div>

        <div class="th">
          <div class="info1">商品信息</div>
          <div class="info2">单价</div>
          <div class="info3">规格</div>
          <div class="info4">数量</div>
          <div class="info5">金额</div>
        </div>

        <div class="item-list-wrap confirm-item-list-wrap">
          <div class="cart-item order-item" v-for="(item,index) in checkedList" :key="index">
            <div class="cart-item-head">{{item.providerName}}
            </div>
            <ul class="cart-item-list" v-for="(item1,index1) in item.data" :key="index1">
              <li>
                <div class="cart-tab-1" >
                  <div class="cart-item-pic">
                    <img :src="item1.img">
                  </div>
                  <div class="cart-item-title">
                    <div class="item-name">{{item1.itemName}}</div>
                  </div>
                </div>
                <div class="cart-tab-2">
                  <div class="item-price">￥{{item1.specPrice | FormatCurrency(item1.specPrice)}}</div>
                </div>
                <div class="cart-tab-3">
                  <div class="item-price">{{item1.itemSpecList[0].spec}}</div>
                </div>
                <div class="cart-tab-4">
                  <div class="item-quantity">
                    <div class="select-self">
                      <div class="select-self-area">
                        <span class="select-ipt">* {{item1.number}}</span>
                      </div>
                    </div>
                    <!--<div class="item-stock item-stock-no">In Stock</div>-->
                  </div>
                </div>
                <div class="cart-tab-5">
                  <div class="item-price-total">￥{{item1.specPrice * item1.number | FormatCurrency(item1.specPrice *
                    item1.number )}}
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div id="confirm_info">
            <ul>
              <li style="display:flex;" v-if="user.isChannel === 0">
                <span>使用优惠券: </span>
                <div style="margin-left:-5px;">
                  <el-select
                    @change="selectCoupons"
                    v-model="couponValue" :placeholder="ordercouponsList.length===0 ? '无' :'请选择'" :disabled="ordercouponsList.length===0">
                    <el-option
                      v-for="(item, index) in ordercouponsList"
                      :key="index"
                      :label="item.title"
                      :value="index">
                    </el-option>
                  </el-select>
                </div>
              </li>
              <li>
                <span>是否开具发票：</span>{{statusTag(invoiceFlagOpt, invoiceObj.invoiceFlag)}}
              </li>
              <template v-if="invoiceObj.invoiceFlag != 0">
                <li>
                  <span>抬头类型：</span>{{statusTag(userTypeOpt, invoiceObj.userType)}}
                </li>
                <li v-if="invoiceObj.userType == '1'">
                  <span>发票类型：</span>{{statusTag(invoiceTypeOpt, invoiceObj.invoiceType)}}
                </li>
                <li>
                  <span>发票抬头：</span>{{invoiceObj.invoice}}
                </li>
                <template v-if="invoiceObj.userType == '1'">
                  <li>
                    <span>税号：</span>{{invoiceObj.tin}}
                  </li>
                  <template v-if="invoiceObj.invoiceType === '1'">
                    <li>
                      <span>开户银行：</span>{{invoiceObj.bankDeposit}}
                    </li>
                    <li>
                      <span>银行账号：</span>{{invoiceObj.bankAccount}}
                    </li>
                    <li>
                      <span>企业地址：</span>{{invoiceObj.address}}
                    </li>
                    <li>
                      <span>企业电话：</span>{{invoiceObj.mobile}}
                    </li>
                  </template>
                </template>
                <li>
                  <span>寄送类型：</span>{{statusTag(sendTypeOpt, invoiceObj.sendType)}}
                </li>
              </template>
              <!--代理商-->
              <li v-if="user.isChannel == 1 && user.channel.parentId == 0">
                <span>单位名称：</span>{{invoiceObj.dealerName}}
              </li>
              <!--经销商-->
              <li v-if="user.isChannel == 1 && user.channel.parentId != 0">
                <span>单位名称：</span>{{invoiceObj.customerName}}
              </li>
              <li>
                <span>备注：</span>{{invoiceObj.remark}}
              </li>
            </ul>
          </div>
        </div>

        <!-- 代理商暂时不和医院合作 -->
        <!-- <div class="page-title-normal checkout-title" v-if="user.isChannel == 1 && user.channel.parentId == 0 && hospitalList.length">
          <h2><span>选择代理下属医院(选填)</span></h2>
          <el-tag type="info">备注: 未选择代理下属医院, 即表示为代理商自己下单</el-tag>
        </div>
        <div v-if="user.isChannel == 1 && hospitalList.length" style="margin-top:20px;">
          <el-radio-group v-model="checkedId" v-for="(item,index) in hospitalList" :key="index">
            <el-radio @click.native.prevent="clickitem(item.id)" :label="item.id" style="margin:0 30px 30px 0;">{{item.hospitalName}}</el-radio>
          </el-radio-group>
        </div> -->

        <!-- Price count -->
        <div class="footerBar">
          <div class="price-count-wrap">
            <div class="price-count">
              <ul>
                <!--<li>-->
                <!--<span>小计</span>-->
                <!--<span>5000</span>-->
                <!--</li>-->
                <!--<li>-->
                <!--<span>运费:</span>-->
                <!--<span>30</span>-->
                <!--</li>-->
                <!--<li>-->
                <!--<span>折扣:</span>-->
                <!--<span>100</span>-->
                <!--</li>-->
                <li class="order-total-price">
                  <div class="total-price-flexend">
                    <span>原价:</span>
                    <span>￥{{totalMoney | FormatCurrency(totalMoney)}}</span>
                  </div>
                  <div class="total-price-flexend">
                    <span>优惠金额:</span>
                    <span>-￥{{discountAmount | FormatCurrency(discountAmount)}}</span>
                  </div>
                  <div class="total-price-flexend">
                    <span>总价:</span>
                    <span>￥{{totalMoney - discountAmount | FormatCurrency(totalMoney - discountAmount)}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="order-foot-wrap">
            <!--<div class="prev-btn-wrap">-->
            <!--<a class="btn btn&#45;&#45;m">Previous</a>-->
            <!--</div>-->
            <div class="next-btn-wrap">
              <button class="btn_back" @click="toBack">返回上一步</button>
              <button class="btn btn--m btn--red" @click="toOrderSuccess"> &nbsp;&nbsp;确 定&nbsp;&nbsp;</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--<nav-footer></nav-footer>-->

    <pay-code-modal v-bind:c_mdshow='p_mdshow' v-on:c_close='p_close'>
      <p slot="msg">
        扫一扫微信支付
      </p>
      <img slot="code" class="code" :src="payCode" alt="">

      <div slot='btnGroup'>
        <a href="javascript:;" class='btn btn--m' @click='p_close'>取消</a>
      </div>
    </pay-code-modal>
    <!--移动端-->
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>
</template>
<script>
  import '@/assets/css/base.css'
  import '@/assets/css/checkout.css'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread'
  import NavFooter from '@/components/Footer'
  import {getCookie, removeHTMLTag, deepClone, IsPC} from "../../util/util";
  import axios from 'axios'
  import PayCodeModal from "../../components/PayCodeModal";
  import Tabbar from '@/components/Tabbar.vue'

  export default {
    data() {
      return {
        goodsObj: {},
        addressObj: {},
        invoiceObj: {},
        p_showSearch: true,
        p_loginModalFlag: false,
        checkedList: [],
        cartList: [],
        totalMoney: '',
        fromCart: '',
        payCode: '',
        loading: false,
        p_mdshow:false,
        payStatus:0,
        interval:{},
        hospitalList:[],
        checkedId:"",
        checkedSpecId: '',
        payNum:'',
        isWeChat:false,
        code:'0',
        appid: '',
        payType:0,
        qrCodeFlag:1,
        selected: "",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_Filled.png"),
          require("@/assets/me_grey.png")
        ],
        // 优惠券
        ordercouponsList: [],
        couponValue: '',
        discountAmount: '',
        couponCode: '',
        //发票信息
        invoiceFlagOpt: [
          {
            label: '否',
            value: '0'
          },
          {
            label: '是',
            value: '1'
          }
        ],
        userTypeOpt: [
          {
            label: '个人',
            value: '0'
          },
          {
            label: '企业',
            value: '1'
          }
        ],
        invoiceTypeOpt: [
          {
            label: '普通发票',
            value: '0'
          },
          {
            label: '专用发票',
            value: '1'
          }
        ],
        sendTypeOpt: [
          {
            label: '货票同行',
            value: '0'
          },
          {
            label: '货票分离',
            value: '1'
          }
        ],
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || ''
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      checkedGoodsList(){
        return this.$store.state.checkedGoodsList;
      },
      statusTag () {
        return function (arr, code) {
          return (arr.find(e => e.value == code) || { label: '暂无' }).label
        }
      }
    },
    components: {
      PayCodeModal,
      NavHeader,
      NavBread,
      NavFooter,
      Tabbar
    },
    mounted() {
      let orderConfirmParams = JSON.parse(localStorage.getItem('orderConfirmParams'))

      this.totalMoney = orderConfirmParams.totalMoney
      this.fromCart = eval(orderConfirmParams.fromCart)
      this.checkedSpecId = orderConfirmParams.checkedSpecId

      let checkedList = this.checkedGoodsList
      let addressObj = JSON.parse(orderConfirmParams.addressObj)
      this.checkedList = this.mapArr(checkedList)

      this.addressObj = addressObj
      this.invoiceObj =  JSON.parse(orderConfirmParams.invoiceObj)

      if (!getCookie("_token")) {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }else{
        this.getHospitalList()
        this.getCartList()
        this.getOrdercouponsList()

        if(this.isWeChatFun()){
          this.isWeChat = true
          this.getAppid()
        }
      }

    },
    beforeDestroy () {
      // localStorage.removeItem('orderConfirmParams')
    },
    methods: {
      //获取代理商下属医院
      getHospitalList(){
        axios.get("jys/hospital/list",{
          headers:{
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((res)=>{
          if(res.data.code == 0){
            this.hospitalList = res.data.list ? res.data.list : []
          }
        })
      },

      getCartList() {
        let cartList = []
        for (var i = 0; i < this.checkedList.length; i++) {
          for (var j = 0; j < this.checkedList[i].data.length; j++) {
            let list = this.checkedList[i].data[j]
            if (list.checked == true) {
              let obj = {
                id: list.id,
                orderNum: list.number,
                snType: 0,
                itemPrice: list.price,
                itemType: list.type,
                itemSpecId:list.itemSpecList[0].id
              }
              cartList.push(obj)
            }
          }
        }
        this.cartList = cartList
      },

      //选择医院
      clickitem (e) {
        e === this.checkedId ? this.checkedId = '' : this.checkedId = e
      },

      p_close(){
        this.p_mdshow = false;
        clearInterval(this.interval);

        this.$confirm('支付已取消,是否前往"我的订单"重新支付?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '回首页',
          type: 'warning'
        }).then(() => {
          clearInterval(this.interval);
          this.$router.replace("/mine/orderList")
        }).catch(() => {
          clearInterval(this.interval);
          this.providerId?this.$router.replace({path: "/company/index", query: {id: this.providerId}}):this.$router.replace('/')
        });

      },

      //map对象改造数组
      mapArr(arr) {
        let map = {},
          dest = [];
        for (var i = 0; i < arr.length; i++) {
          var ai = arr[i];
          if (!map[ai.providerId]) {
            dest.push({
              providerId: ai.providerId,
              providerName: ai.providerName,
              data: [ai],
              comChecked: false
            });
            map[ai.providerId] = ai;
          } else {
            for (var j = 0; j < dest.length; j++) {
              var dj = dest[j];
              if (dj.providerId == ai.providerId) {
                dj.data.push(ai);
                break;
              }
            }
          }
        }
        return dest
      },

      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },

      formCartOrder(cartList) {
        this.loading = true
        let invoiceObj = deepClone(this.invoiceObj)
        let couponCodeObj = JSON.stringify(this.couponCodeObj)
        // console.log('couponCode', couponCode)
        let remark = {}
        this.checkedList.map((item, index, arr) => {
          remark[item.providerId] = invoiceObj.remark
        })
        invoiceObj.remark = JSON.stringify(remark)
        axios.post("jys/pay/cart?shopId=" + this.providerId, {
          userName: this.addressObj.userName,
          telNumber: this.addressObj.telNumber,
          provinceName: this.addressObj.provinceName,
          cityName: this.addressObj.cityName,
          countyName: this.addressObj.countyName,
          detailInfo: this.addressObj.detailInfo,
          payType: this.payType,
          code: this.code,
          qrCodeFlag: this.qrCodeFlag,
          cartList: cartList,
          orderPlatform: 1,
          hospitalId:this.checkedId && this.user.isChannel == 1 ? this.checkedId :'',
          //发票信息
          ...invoiceObj,
          couponCode: couponCodeObj
        }, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token"),
            "pcKey": getCookie("pc"),
          }
        }).then((response) => {
          this.loading = false
          if (response.data.code == 3000) {
            //代理商下单成功
            this.loading = false
            this.$router.replace({path:"/orderSuccess",query:{orderType:this.checkedId ? 2 : 1}})
          }

          else if (response.data.code == 0) {
            //普通用户下单成功
            this.loading = false
            let result = response.data.result
            let codeUrlPng = result.codeUrlPng
            let orderNo = result.orderNo
            if(this.payType == 3){
              if (this.qrCodeFlag == 0) {
                if(typeof WeixinJSBridge == "undefined") {
                  if(document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                  } else if(document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                  }
                } else {
                  this.onBridgeReady(result);
                }
              } else {
                location.href = response.data.result.mwebUrl
              }
            }else{
              this.p_mdshow = true
              this.payCode = 'data:image/png;base64,' + codeUrlPng
            }

            var interval = setInterval(() =>{
              this.getPayStatus(orderNo)

              if(this.payStatus == 1){
                clearInterval(interval);
                let itemTypes = this.checkedList[0].data[0].type
                let payNums = response.data.payNum
                this.$router.replace({path:"/orderSuccess",query:{'itemType':itemTypes,'payNum':payNums}})
              }
            }, 2000);

            this.interval = interval
          }

          else if(response.data.code == 3001){
            //普通用户测试环境支付成功
            this.$message.success("测试环境支付成功")
            let itemTypes = this.checkedList[0].data[0].type
            let payNums = response.data.payNum
            this.$router.replace({path:"/orderSuccess",query:{'itemType':itemTypes,'payNum':payNums}})
          }

          else {
            if (this.isWeChatFun()) {
              let href = location.href;
              let posit = href.indexOf("com/") + 4; //获取域名结束的位置
              let urlLeft = href.substring(0, posit);//url左侧部分
              let urlRight = href.split('#')[1]; //url右侧部分
              let url = urlLeft + "#" + urlRight;//拼接跳转
              window.history.pushState({}, 0, url)
            }
            setTimeout(() => {
              this.$router.replace("/cart")
            }, 200)
          }
        }).catch((response) => {

        })
      },

      fromDetailOrder(goodsObj) {
        this.loading = true
        axios.post("/jys/pay", {
          userName: this.addressObj.userName,
          telNumber: this.addressObj.telNumber,
          provinceName: this.addressObj.provinceName,
          cityName: this.addressObj.cityName,
          countyName: this.addressObj.countyName,
          detailInfo: this.addressObj.detailInfo,
          itemId: goodsObj.id,
          itemNum: goodsObj.number,
          snType: 0,
          itemType: goodsObj.type,
          orderPlatform: 1,
          itemPrice: goodsObj.price,
          code: this.code,
          payType: this.payType,
          qrCodeFlag: this.qrCodeFlag,
          hospitalId:this.checkedId && this.user.isChannel == 1 ? this.checkedId :'',
          itemSpecId:this.checkedSpecId,
          //发票信息
          ...this.invoiceObj,
          couponCode: this.couponCode
        }, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token"),
            "pcKey": getCookie("pc"),
          }
        }).then((response) => {
          this.loading = false
          if (response.data.code == 3000) {
            //代理商下单成功
            this.loading = false
            this.$router.replace({path:"/orderSuccess",query:{orderType:this.checkedId ? 2 : 1}})
          }

          else if (response.data.code == 0) {
            //普通用户下单成功
            this.loading = false
            let result = response.data.result
            let codeUrlPng = result.codeUrlPng
            let orderNo = result.orderNo
            if(this.payType == 3){
              if (this.qrCodeFlag == 0) {
                if(typeof WeixinJSBridge == "undefined") {
                  if(document.addEventListener) {p
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                  } else if(document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                  }
                } else {
                  this.onBridgeReady(result);
                }
              } else {
                location.href = response.data.result.mwebUrl
              }
            }else{
              this.p_mdshow = true
              this.payCode = 'data:image/png;base64,' + codeUrlPng
            }

            var interval = setInterval(() =>{
              this.getPayStatus(orderNo)

              if(this.payStatus == 1){
                clearInterval(interval);
                let itemTypes = this.checkedList[0].data[0].type
                let payNums = response.data.payNum
                this.$router.replace({path:"/orderSuccess",query:{'itemType':itemTypes,'payNum':payNums}})
              }
            }, 2000);

            this.interval = interval

          }

          else if(response.data.code == 3001){
            //普通用户测试环境支付成功
            this.$message.success("测试环境支付成功")
            let itemTypes = this.checkedList[0].data[0].type
            let payNums = response.data.payNum
            this.$router.replace({path:"/orderSuccess",query:{'itemType':itemTypes,'payNum':payNums}})
          }

          else{
            if (this.isWeChatFun()) {
              let href = location.href;
              let posit = href.indexOf("com/") + 4; //获取域名结束的位置
              let urlLeft = href.substring(0, posit);//url左侧部分
              let urlRight = href.split('#')[1]; //url右侧部分
              let url = urlLeft + "#" + urlRight;//拼接跳转
              window.history.pushState({}, 0, url)
            }
            // setTimeout(() => {
            //   this.$router.push({
            //     path: "detection",
            //     query: {
            //       id: goodsObj.id
            //     }
            //   })
            // }, 200)
          }
        }).catch((response) => {

        })
      },

      //获取订单支付状态
      getPayStatus(orderNo){
        axios.get("/jys/pay/status/" + orderNo,{
          headers:{
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          if(response.data.code == 0){
            let status = response.data.status
            this.payStatus = status

          }
        })
      },

      toOrderSuccess() {
        window.scrollTo(0, 0)
        let cartList = this.cartList
        if(!IsPC()){
          // 非个人用户不调起支付
          if (this.user.isChannel === 0) {
            let isSupport = false
            if (this.isWeChatFun()) {
              // 微信浏览器都支持
              isSupport = true
            } else {
              // 手机浏览器只支持之江
              isSupport = this.checkedList[0].providerId === 1 || this.checkedList[0].providerId === 21;
            }
            if (isSupport) {
              this.$confirm('请选择支付方式?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '微信支付',
                cancelButtonText: '生成二维码',
                type: 'warning',
                center: true,
                showClose: true
              }).then(() => {
                if (this.isWeChatFun()) {
                  this.qrCodeFlag = 0
                } else {
                  this.qrCodeFlag = 2
                }
                this.payType = 3
                if (this.fromCart) {
                  this.formCartOrder(cartList)
                } else {
                  let goodsObj = this.checkedList[0].data[0]
                  this.fromDetailOrder(goodsObj)
                }
              }).catch(action => {
                if(action === 'cancel'){
                  window.scrollTo(0, 0)
                  this.payType = 0
                  this.qrCodeFlag = 1
                  if (this.fromCart) {
                    this.formCartOrder(cartList)
                  } else {
                    let goodsObj = this.checkedList[0].data[0]
                    this.fromDetailOrder(goodsObj)
                  }
                }else{
                  this.$message.error('支付已取消')
                }
              });
            } else {
              window.scrollTo(0, 0)
              this.payType = 0
              this.qrCodeFlag = 1
              if (this.fromCart) {
                this.formCartOrder(cartList)
              } else {
                let goodsObj = this.checkedList[0].data[0]
                this.fromDetailOrder(goodsObj)
              }
            }

          } else {
            this.payType = 0
            this.qrCodeFlag = 1
            if (this.fromCart) {
              this.formCartOrder(cartList)
            } else {
              let goodsObj = this.checkedList[0].data[0]
              this.fromDetailOrder(goodsObj)
            }
          }
        } else {
          window.scrollTo(0, 0)
          // console.log('非微信浏览器')
          this.payType = 0
          this.qrCodeFlag = 1
          if (this.fromCart) {
            this.formCartOrder(cartList)
          } else {
            let goodsObj = this.checkedList[0].data[0]
            this.fromDetailOrder(goodsObj)
          }
        }
      },

      toBack() {
        this.$router.go(-1)
      },

      //判断是否是微信浏览器
      isWeChatFun(){
        let ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          return true;
        }else{
          return false;
        }
      },
      //获取地址栏参数
      GetQueryString(name) {
        let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
      },
      //微信获取appid
      getAppid(){
        let params = {}
        if (this.fromCart) {
          let ids = ''
          this.cartList.map((item, index, arr) => {
            ids = ids + item.id + ','
          })
          params = {
            itemIds: ids.substring(0, ids.length - 1)
          }
        } else {
          params = {
            itemId: this.checkedList[0].data[0].id
          }
        }
        axios.get("/jys/pay/appid", {
          params: params
        }).then((res) => {
          if (res.data.code === 0) {
            this.appid = res.data.appid
            this.getCode(res.data.appid)
          }
        })
      },
      //微信授权获取code
      getCode(appid){
        let code = this.GetQueryString('code')
        if(code != null && code.toString().length>1) {
          this.code = code
        }else{
          //redirect_uri授权后重定向的回调链接地址
          location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=0&connect_redirect=1#wechat_redirect';
        }
      },
      //微信支付
      onBridgeReady(data){
        let that = this
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": data.appid,//公众号名称
            "timeStamp": data.timeStamp,//时间戳
            "nonceStr": data.nonceStr, //随机串
            "package": data.package,
            "signType":"MD5",//微信签名方式
            "paySign": data.paySign//微信签名
          },
          function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ) {

            }else if(res.err_msg == "get_brand_wcpay_request:cancel") {
              // that.$confirm('支付已取消,是否前往"我的订单"重新支付?', '提示', {
              //   confirmButtonText: '确定',
              //   cancelButtonText: '回首页',
              //   type: 'warning'
              // }).then(() => {
              //   clearInterval(that.interval);
              //   that.$router.replace("/mine/orderList")
              // }).catch(() => {
              //   clearInterval(that.interval);
              //   that.$router.replace("/")
              // });
              that.reload()
            }else if(res.err_msg == "get_brand_wcpay_request:fail"){
              that.reload()
              that.$message.error(JSON.stringify(res))
            }else{
              that.reload()
            }
          }
        )
      },
      // 优惠券
      getOrdercouponsList() {
        axios.post('/ai/coupon/order', {
          platform: 'ZYJY',
          orderItems: this.cartList
        }).then((res) => {
          console.log('res', res)
          if (res.data.code == 0) {
            console.log('res.data', res.data)
            this.ordercouponsList = res.data.list
            this.ordercouponsList.push({title: '不使用优惠券'})
            var ordercouponsList = res.data.list
            var curDate = new Date().getTime()
            for (var i = 0; i < ordercouponsList.length; i++) {
              if (ordercouponsList[i].rangeEndTime) {
                ordercouponsList[i].rangeEndTime = ordercouponsList[i].rangeEndTime.replace(/-/g, '/')
                ordercouponsList[i].rangeBeginTime = ordercouponsList[i].rangeBeginTime.replace(/-/g, '/')
                var endDate = Date.parse(new Date(ordercouponsList[i].rangeEndTime))
                var beginDate = Date.parse(new Date(ordercouponsList[i].rangeBeginTime))
                if ((beginDate - curDate) > 0) {
                  ordercouponsList[i].isShowBeginDate = true
                } else {
                  ordercouponsList[i].isShowBeginDate = false
                }
              }
            }
          }
        })
      },
      selectCoupons (value) {
        if (value === this.ordercouponsList.length - 1) {
          this.couponValue = '不使用优惠券'
          this.discountAmount = '0.00'
          this.couponCode = ''
          this.couponCodeObj = {}
        } else {
          this.discountAmount = this.ordercouponsList[value].discountAmount
          let _couponCodeObj = {}
          let _providerId = (this.ordercouponsList[value].provider).toString()

          this.couponCode = this.ordercouponsList[value].giveCode
          _couponCodeObj[_providerId] = this.couponCode
          this.couponCodeObj = _couponCodeObj
        }
      },
      //重新加载
      reload(){
        let href = location.href;
        var posit = href.indexOf("com/") + 4; //获取域名结束的位置
        var urlLeft = href.substring(0, posit);//url左侧部分
        var urlRight = href.split('#')[1]; //url右侧部分
        location.href = urlLeft + "#" + urlRight;//拼接跳转
      }
    }
  }
</script>
<style scoped>
  .th {

    height: 60px;
    line-height: 60px;
  }

  .th>div{
    text-align: center;
    float: left;
  }

  .info1 {
    width: 40%;
  }

  .info2 {
    width: 15%;
  }

  .info3 {
    width: 15%;
  }

  .info4 {
    width: 15%;
  }

  .info5 {
    width: 15%;
  }

  .container {
    width: 70%;
  }
  #confirm_info{
    margin-bottom: 150px;
  }
  #confirm_info,
  #confirm_info ul{
    width: 100%;
    float: left;
  }

  #confirm_info li{
    width: 100%;
    float: left;
    padding-bottom: 12px;
    word-wrap: break-word;
  }

  #confirm_info span{
    display: inline-block;
    width: 140px;
    font-weight: bolder;
  }

  .footerBar {
    width:70%;
    padding-bottom:15px;
    position: fixed;
    bottom: 0px;
    right: 15%;
    background: #fff;
  }

  .btn_back{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    padding: 12px 20px;
    margin-right: 15px;
    font-size: 14px;
  }
  .cart-item{display: block;}
  .mshow{
    display: none;}

  .total-price-flexend {
    display: flex;
    justify-content: flex-end;
  }

  .price-count .total-price-flexend span {
    width: auto;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .container {
      margin: 20px auto 90px;width: 96%;
    }
    .el-col-24,.th{
      display: none;}
    .mshow{
      display: block;}
    /deep/ .navbar{
      display: none;
    }
    .container {
      width: 95%;margin: 0 auto 180px!important;
    }
    .order-foot-wrap,.price-count-wrap{
      position: fixed;
      left: 0;
      right: 10px;
      bottom: 55px;
      background-color: #fff;
    }
    .price-count-wrap{
      left: 10px;
      bottom: 81px;
    }
    #confirm_info span{
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderConfirmbk.vue